import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SeoGuide from "../pages/seo-guide/page";
import SeoArticlePage from "../pages/seo-article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-sheet-seo-guide",
    element: <SeoGuide />,
  },
  {
    path: "/seo/:slug",
    element: <SeoArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;